<template>
  <div>
    <transfer-mess :body="body" v-transition></transfer-mess>
  </div>
</template>

<script>
import TransferMess from './components/Mess'
export default {
  name: 'Transfer',
  components: {
    TransferMess
  },
  data () {
    return {
      body: {}
    }
  },
  methods: {
    getTranInfo () {
      this.axios.get('/ApiMe/AccountTransfer')
        .then(this.getTranInfoSucc)
        .catch(this.getTranInfoFail)
    },
    getTranInfoSucc (res) {
      res = res.data
      if (res.ret && res.data) {
        const data = res.data
        this.body = JSON.parse(data.body)
      }
    },
    getTranInfoFail () {
      alert('获取数据失败')
    }
  },
  mounted () {
    this.getTranInfo()
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/transfer/Transfer.vue